import * as fileActions from './actions';
import * as fileDataActions from './filedata/actions';
import {ActionType, getType} from "typesafe-actions";
import {IFileSystemState} from "./types";
import {Reducer} from "redux";
import {addFile, deleteFile, loadingFiles, mergeFiles} from "./utils";
import {deleteFileData, mergeFileData} from "./filedata/utils";
import {defaultFileData} from "./defaults";

export type FileActions = ActionType<typeof fileActions>;
export type FileDataActions = ActionType<typeof fileDataActions>;


const initialFilesState: IFileSystemState = {
    files: {
        byId: {},
    },
    filesData: {
        byId: {},
    },
    selectedFileId: '',
    checkedFileIds: {
        fileIds: [],
        folderIds: []
    },
    activeFileData: defaultFileData,
    isSavingFileData: false,
    isFilesLoading: false
};

export const filesReducer: Reducer<IFileSystemState, FileActions | FileDataActions> = (
    state = initialFilesState,
    action
) => {
    switch (action.type) {
        case getType(fileActions.fetchFileRootWithChildrenAsyncActions.request): {
            return loadingFiles(state)
        }
        case getType(fileActions.fetchFileChildrenAsyncActions.request): {
            return loadingFiles(state)
        }
        case getType(fileActions.fetchFileRootWithChildrenAsyncActions.success): {
            return mergeFiles(state, action.payload.files)
        }
        case getType(fileActions.fetchAllFilesAsyncActions.success): {
            return mergeFiles(state, action.payload.files)
        }
        case getType(fileActions.fetchFileChildrenAsyncActions.success): {
            return mergeFiles(state, action.payload.files)
        }
        case getType(fileActions.addFileAsyncActions.success): {
            return addFile(state, action.payload.file)
        }
        case getType(fileActions.renameFileAsyncActions.success): {
            return mergeFiles(state, action.payload.files)
        }
        case getType(fileActions.moveFileAsyncActions.success): {
            return mergeFiles(state, action.payload.files)
        }
        case getType(fileActions.deleteFileAsyncActions.success): {
            return deleteFile(state, action.payload.file.id)
        }
        case getType(fileActions.selectFileAsyncAction.success): {
            let {fileData} = action.payload;
            let updated = state;
            if (fileData && fileData.id) {
                updated = mergeFileData(state, {byId: {[fileData.id]: fileData}})
            }
            return {
                ...updated,
                selectedFileId: action.payload.id,
                activeFileData: fileData
            }
        }
        case getType(fileActions.checkFilesAsyncAction.success): {
            return {
                ...state,
                checkedFileIds: {
                    fileIds: [
                        ...action.payload.checkedFileIds.fileIds
                    ],
                    folderIds: [...action.payload.checkedFileIds.folderIds]
                }
            }
        }

        // FileData
        case getType(fileDataActions.fetchFileDataByIdAsyncActions.success): {
            return mergeFileData(state, {byId: {[action.payload.fileData.id]: action.payload.fileData}})
        }
        case getType(fileDataActions.fetchFileDataAsyncActions.success): {
            return mergeFileData(state, action.payload.fileDataList)
        }
        case getType(fileDataActions.saveFileDataAsyncActions.request): {
            return {
                ...state,
                isSavingFileData: true,
            }
        }
        case getType(fileDataActions.saveFileDataAsyncActions.success): {
            return mergeFileData(state, {byId: {[action.payload.fileData.id]: action.payload.fileData}})
        }
        case getType(fileDataActions.deleteFileDataAsyncActions.success): {
            return deleteFileData(state, action.payload.id)
        }
        case getType(fileDataActions.loadDataForFilesAsyncAction.success): {
            return {
                ...state,
                filesData: {
                    ...state.filesData,
                    byId: {
                        ...state.filesData.byId,
                        ...action.payload.filesData.byId
                    }
                }
            }
        }
        case getType(fileDataActions.modifyingActiveFileDataAction): {
            let fileData
            if (state.activeFileData) {
                fileData = {
                    ...state.activeFileData,
                    ...action.payload.fileData
                }
            }
            return {
                ...state,
                activeFileData: fileData
            }
        }
        default:
            return state
    }
};